var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"marquee"},[_vm._m(0),_c('div',{staticClass:"marquee-viewport"},[_c('div',{staticClass:"marquee-track"},_vm._l((_vm.loopList),function(t,i){return _c('span',{key:i,staticClass:"marquee-item"},[_vm._v(_vm._s(t)),_c('i')])}),0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marquee-label"},[_c('span',{staticClass:"eyebrow"},[_vm._v("Tech Stack")])])
}]

export { render, staticRenderFns }